<template>
  <div class="nv-page">
    <!-- Bağlantı Durumu -->
    <div class="nv-card nv-status-card">
      <div class="nv-status-card__body">
        <span class="nv-pulse">
          <v-icon color="white">mdi-lan-pending</v-icon>
        </span>
        <div class="nv-status-card__text">
          <h3>Web soket uygulamasına bağlanılıyor...</h3>
          <p>
            Bağlantı bulunana kadar otomatik olarak tekrar denenecektir. Bağlantı kurulduğunda giriş ekranına
            yönlendirileceksiniz.
          </p>
        </div>
        <v-btn
            outlined
            color="primary"
            class="nv-btn"
            :loading="manualLoading"
            :disabled="manualLoading"
            @click="manualConnect">
          <v-icon small left>mdi-refresh</v-icon>
          Şimdi Dene
        </v-btn>
      </div>
      <v-progress-linear indeterminate color="secondary" height="3"></v-progress-linear>
    </div>

    <v-row class="mt-2">
      <!-- Başlangıç Adımları -->
      <v-col cols="12" lg="7">
        <div class="nv-card h-100">
          <div class="nv-card__header">
            <div>
              <h4 class="nv-card__title">Bağlantı kurulamadı mı?</h4>
              <p class="nv-card__subtitle">Aşağıdaki adımları takip ederek kolayca başlayabilirsiniz.</p>
            </div>
          </div>
          <ol class="nv-steps">
            <li class="nv-steps__item">
              <span class="nv-steps__num">1</span>
              <div class="nv-steps__content">
                <strong>Web soket uygulamasını indirin</strong>
                <p>Eğer web soket uygulamasına sahip değilseniz aşağıdaki bağlantıdan indirebilirsiniz.</p>
                <v-btn
                    target="_blank"
                    href="https://test-setup.obs.tr-west-1.myhuaweicloud.com/Activation/Activation_Socket.exe"
                    color="secondary"
                    depressed
                    class="nv-btn mt-1">
                  <v-icon small left>mdi-cloud-download-outline</v-icon>
                  Uygulamayı İndir
                </v-btn>
              </div>
            </li>
            <li class="nv-steps__item">
              <span class="nv-steps__num">2</span>
              <div class="nv-steps__content">
                <strong>Uygulamayı çalıştırın</strong>
                <p>Web soket uygulamasının açık olduğundan ve işlem bitene kadar açık kalacağından emin olunuz.</p>
              </div>
            </li>
            <li class="nv-steps__item">
              <span class="nv-steps__num">3</span>
              <div class="nv-steps__content">
                <strong>Otomatik olarak yönlendirileceksiniz</strong>
                <p>
                  Bağlantı kurulduğunda giriş ekranı açılır. Beklemek istemiyorsanız
                  <a class="nv-link" @click="manualConnect">bağlantıyı şimdi kontrol edin</a>.
                </p>
              </div>
            </li>
          </ol>
        </div>
      </v-col>

      <!-- Gereksinimler -->
      <v-col cols="12" lg="5">
        <div class="nv-card h-100">
          <div class="nv-card__header">
            <div>
              <h4 class="nv-card__title">Gereksinimler</h4>
              <p class="nv-card__subtitle">İşleme başlamadan önce kontrol ediniz.</p>
            </div>
          </div>
          <ul class="nv-checklist">
            <li>
              <v-icon small color="secondary">mdi-check-circle</v-icon>
              <span>
                Bilgisayarınızda <b>Java</b> kurulu olmalıdır. Java kurulu değilse indirmek için
                <a class="nv-link" href="https://www.java.com/tr/download/manual.jsp" target="_blank" rel="noopener">tıklayınız</a>.
              </span>
            </li>
            <li>
              <v-icon small color="secondary">mdi-check-circle</v-icon>
              <span>e-İmza / Mali Mühürün bilgisayarınıza takılı olması gerekmektedir.</span>
            </li>
            <li>
              <v-icon small color="secondary">mdi-check-circle</v-icon>
              <span>Web soket bağlantısının, işlem bitene kadar açık kalması gerekmektedir.</span>
            </li>
            <li>
              <v-icon small color="secondary">mdi-check-circle</v-icon>
              <span>e-İmza / Mali Mühür sürücülerinin kurulu olması gerekmektedir.</span>
            </li>
            <li>
              <v-icon small color="secondary">mdi-check-circle</v-icon>
              <span>e-İmza / Mali Mühür yazılımlarının kurulu olması gerekmektedir. (AKİS, vb.)</span>
            </li>
          </ul>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import action from "../../../core/services/WebSocket/action";

export default {
  name: "SigningProcedures",
  data() {
    return {
      timer: "",
      manualLoading: false
    };
  },
  created() {
    this.tryConnect();
    this.timer = setInterval(this.tryConnect, 5000);
  },
  methods: {
    toastError(error) {
      this.$bvToast.toast(error, {
        toaster: 'b-toaster-bottom-right',
        title: 'Hata',
        variant: 'danger',
        solid: true,
        autoHideDelay: 3000,
        bodyClass:"toastError-body",
        headerClass:"toastError-header",
        toastClass:"toastError-container"
      });
    },
    cancelAutoUpdate() {
      clearInterval(this.timer);
      // eslint-disable-next-line vue/custom-event-name-casing
      this.$emit("swapCardTitle", "Kart Seçiniz");
      // eslint-disable-next-line vue/custom-event-name-casing
      this.$emit("swapComponent", "SelectSlots");
    },
    async manualConnect() {
      if (this.manualLoading) return;
      this.manualLoading = true;
      const connected = await this.tryConnect();
      this.manualLoading = false;
      if (!connected) {
        this.toastError("Web soket uygulamasına bağlanılamadı. Uygulamanın çalıştığından emin olunuz.");
      }
    },
    async tryConnect() {
      let response = await action.CheckConnetion();
      if (response && response.status == 200) {
        this.$router.push("/login", () => {});
        return true;
      }
      return false;
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
}
</script>
